import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "../../components/navbar";
import Sidebar from "../../components/Sidebar";
// import Footer from "components/footer/Footer";
import { useSelector } from "react-redux";
// Admin Imports
import MainDashboard from "views/admin/default";
import Profile from "views/admin/profile";
// import DataTables from "views/admin/tables";
import SignIn from "views/auth/SignIn";
import UserAdd from "views/admin/user/UserAdd";
import User from "views/admin/user/User";
import UserEdit from "views/admin/user/UserEdit";
import UserDelete from "views/admin/user/UserDelete";
import BlogsFormEdit from "views/blogs/BlogFormEdit";
import BlogDelete from "views/blogs/DeleteBlog";
import Survey from "views/survey/survey";
import SingleSurvey from "views/survey/singleSurvey";
import JobPostingList from "views/jobPostings/JobPostingList";
import JobPostingForm from "views/jobPostings/JobPostingForm";
import JobPostingPreview from "views/jobPostings/JobPostingPreview";
import JobLeadList from "views/jobPostings/JobLeadList";
import Attendance from "views/attendance/Attendance";
import Payroll from "views/payroll/Payroll";

// Icon Imports
import { MdHome, MdPerson, MdAttachMoney } from "react-icons/md";
import { ImBlog } from "react-icons/im";
import { FaUserFriends } from "react-icons/fa";
import {BsSignpost2Fill} from "react-icons/bs";
import { AiOutlineLogout } from "react-icons/ai";
import {RiSurveyLine} from 'react-icons/ri';
import { MdAnnouncement } from "react-icons/md";
import SignOut from "views/auth/SignOut";
import BlogsForm from "views/blogs/BlogsForm";
import Blogs from "views/blogs/Blogs";
import Announcements from "views/announcements/Announcements";
import AnnouncementForm from "views/announcements/AnnouncementForm";
import AnnouncementEdit from "views/announcements/AnnouncementEdit";
import DeleteAnnouncement from "views/announcements/DeleteAnnouncement";
import AnnouncementDetail from "views/announcements/AnnouncementDetail";
import { getUserDataByToken } from "proxyUrl";
import ErrorPaheInner from "views/ErrorPaheInner";
import axios from "axios";
import Employees from "views/attendance/Employees";

export default function Admin(props) {
  const [permission, setPermission] = useState();
  const userDataByApi = async () => {
    await axios
      .get(getUserDataByToken, {
        withCredentials: true,
      })
      .then((res) => {
        setPermission(res.data.user.userPermission)
        return res;
      });
  };

  const routesLinks = [
    {
      name: "Dashboard",
      layout: `/admin`,
      path: "dashboard",
      icon: <MdHome className="h-6 w-6" />,
      display: "",
      component: <MainDashboard />,
    },
  
  ];
  useEffect(() => { 
    
    userDataByApi();
   
  }, []);
  // generate routes ***************************
  
  const logged_user_info = useSelector((state) => state.user.user);
  if (!logged_user_info.userPermission) {
  }
  const userPermissions = logged_user_info.userPermission
    ? logged_user_info.userPermission
    : permission;
  if (userPermissions) {
    userPermissions.forEach((element) => {
      // *************************** USER MANAGEMENT ***************************
      if (element === "userAdd") {
        routesLinks.push(
          {
            name: "Users",
            layout: `/${`admin`}`,
            icon: <FaUserFriends className="h-6 w-6" />,
            path: "users",
            display: "",
            component: <User />,
          },
          {
            name: "add user",
            layout: `/${`admin`}`,
            path: "users/add",
            display: "hidden",
            icon: "",
            component: <UserAdd />,
          }
        );
      } else if (element === "userEdit") {
        routesLinks.push({
          name: "edit user",
          layout: `/${`admin`}`,
          path: "users/edit/:id",
          display: "hidden",
          icon: "",
          component: <UserEdit />,
        });
      } else if (element === "userDelete") {
        routesLinks.push({
          name: "edit user",
          layout: `/${`admin`}`,
          path: "users/delete/:id",
          display: "hidden",
          icon: "",
          component: <UserDelete />,
        });

        // *************************** BLOGS & RELATED MODULES ***************************
      } else if (element === "blog") {
        routesLinks.push(
          {
            name: "Blogs",
            layout: `/${`admin`}`,
            path: "blogs",
            display: "",
            icon: <ImBlog className="h-6 w-6" />,
            component: <Blogs />,
          },
          {
            name: "Attendance",
            layout: `/${`admin`}`,
            path: "attendance",
            display: "",
            icon: <MdAnnouncement className="h-6 w-6" />,
            component: <Attendance />,
          },
          {
            name: "Payroll",
            layout: `/${`admin`}`,
            path: "payroll",
            display: "",
            icon: <MdAttachMoney className="h-6 w-6" />,
            component: <Payroll />,
          },
          {
            name: "Employees",
            layout: `/${`admin`}`,
            path: "employees",
            display: "",
            icon: <MdPerson className="h-6 w-6" />,
            component: <Employees />,
          },
          {
            name: "Survey",
            layout: `/${`admin`}`,
            path: "survey/all",
            display: "",
            icon: < RiSurveyLine className="h-6 w-6" />,
            component: < Survey />,
          },
          {
            name: "Single Survey",
            layout: `/${`admin`}`,
            path: "survey/single",
            display: "hidden",
            icon: < RiSurveyLine className="h-6 w-6" />,
            component: < SingleSurvey />,
          },
          {
            name: "BlogAdd",
            layout: `/${`admin`}`,
            path: "blogs/add",
            display: "hidden",
            icon: <ImBlog className="h-6 w-6" />,
            component: <BlogsForm />,
          },
          {
            name: "BlogEdit",
            layout: `/${`admin`}`,
            path: "blogs/edit/:id",
            display: "hidden",
            icon: <ImBlog className="h-6 w-6" />,
            component: <BlogsFormEdit />,
          },
          {
            name: "BlogDelete",
            layout: `/${`admin`}`,
            path: "blogs/delete/:id",
            display: "hidden",
            icon: <ImBlog className="h-6 w-6" />,
            component: <BlogDelete />,
          },
        );
      }

      // *************************** JOB POSTINGS MODULE ***************************
      // View job postings (list + details + leads)
      if (element === "view Job posting") {
        routesLinks.push(
          {
            name: "Job Postings",
            layout: `/${`admin`}`,
            path: "job-postings",
            display: "",
            icon: <BsSignpost2Fill className="h-6 w-6" />,
            component: <JobPostingList />,
          },
          {
            name: "Job Preview",
            layout: `/${`admin`}`,
            path: "job-postings/:id/preview",
            display: "hidden",
            icon: <BsSignpost2Fill className="h-6 w-6" />,
            component: <JobPostingPreview />,
          },
          {
            name: "Job Leads",
            layout: `/${`admin`}`,
            path: "job-postings/:id/leads",
            display: "hidden",
            icon: <BsSignpost2Fill className="h-6 w-6" />,
            component: <JobLeadList />,
          }
        );
      }

      // Create job posting
      if (element === "create Job posting") {
        routesLinks.push({
          name: "Job Create",
          layout: `/${`admin`}`,
          path: "job-postings/create",
          display: "hidden",
          icon: <BsSignpost2Fill className="h-6 w-6" />,
          component: <JobPostingForm />,
        });
      }

      // Update job posting
      if (element === "update Job posting") {
        routesLinks.push({
          name: "Job Edit",
          layout: `/${`admin`}`,
          path: "job-postings/:id/edit",
          display: "hidden",
          icon: <BsSignpost2Fill className="h-6 w-6" />,
          component: <JobPostingForm />,
        });
      }

      // *************************** ANNOUNCEMENTS MODULE ***************************
      // View announcements (list + detail)
      if (element === "view announcement" || element === "view all announcement") {
        // Avoid pushing duplicate sidebar entries if user has both permissions
        const hasAnnouncementsRoute = routesLinks.some(
          (r) => r.path === "announcements" && r.layout === "/admin"
        );
        if (!hasAnnouncementsRoute) {
          routesLinks.push(
            {
              name: "Announcements",
              layout: `/${`admin`}`,
              path: "announcements",
              display: "",
              icon: <MdAnnouncement className="h-6 w-6" />,
              component: <Announcements />,
            },
            {
              name: "AnnouncementDetail",
              layout: `/${`admin`}`,
              path: "announcements/view/:id",
              display: "hidden",
              icon: <MdAnnouncement className="h-6 w-6" />,
              component: <AnnouncementDetail />,
            }
          );
        }
      }

      // Create announcement
      if (element === "create announcement") {
        routesLinks.push({
          name: "AnnouncementAdd",
          layout: `/${`admin`}`,
          path: "announcements/add",
          display: "hidden",
          icon: <MdAnnouncement className="h-6 w-6" />,
          component: <AnnouncementForm />,
        });
      }

      // Update announcement
      if (element === "update announcement") {
        routesLinks.push({
          name: "AnnouncementEdit",
          layout: `/${`admin`}`,
          path: "announcements/edit/:id",
          display: "hidden",
          icon: <MdAnnouncement className="h-6 w-6" />,
          component: <AnnouncementEdit />,
        });
      }

      // Delete announcement
      if (element === "delete announcement") {
        routesLinks.push({
          name: "AnnouncementDelete",
          layout: `/${`admin`}`,
          path: "announcements/delete/:id",
          display: "hidden",
          icon: <MdAnnouncement className="h-6 w-6" />,
          component: <DeleteAnnouncement />,
        });
      }
    });
  }
    routesLinks.push(
      {
        name: "Profile",
        layout: `/${`admin`}`,
        path: "profile",
        display: "hidden",
        icon: <MdPerson className="h-6 w-6" />,
        component: <Profile />,
      },
      {
        name: "Log In",
        layout: "/auth",
        path: "sign-in",
        display: "hidden",
        icon: <AiOutlineLogout className="h-6 w-6" />,
        component: <SignIn />,
      },
      {
        name: "Log Out",
        layout: "/auth",
        path: "sign-out",
        display: "",
        icon: <AiOutlineLogout className="h-6 w-6" />,
        component: <SignOut />,
      }
    );

  // generate routes ***************************
  const { ...rest } = props;
  const [open, setOpen] = useState(true);

  const [currentRoute, setCurrentRoute] = useState("Dashboard");

  useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);

 

  const getActiveRoute = (routes) => {
    let activeRoute = "Dashboard";
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(
          routes[i].layout + "/" + routes[i].path
        ) !== -1
      ) {
        setCurrentRoute(routes[i].name);
      }
    }
    return activeRoute;
  };

  useEffect(() =>{
    getActiveRoute(routesLinks);
  })

  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].secondary;
      }
    }
    return activeNavbar;
  };
  document.documentElement.dir = "ltr";
  return (
    <div className="flex h-full w-full bg-gray-50 dark:bg-slate-900">
      <Sidebar
        open={open}
        routes={routesLinks}
        onClose={() => setOpen(false)}
      />
      {/* Navbar & Main Content */}
      <div className="h-full w-full">
        {/* Main Content */}
        <main
          className={`h-full flex-none transition-all xl:ml-[200px]`}
        >
          {/* Routes */}
          <div className="h-full">
            <div className="sticky top-0 z-30 bg-gray-50 dark:bg-slate-900 px-6 pt-4 pb-2">
              <Navbar
                onOpenSidenav={() => setOpen(true)}
                logoText={" Creed Infotech"}
                brandText={currentRoute}
                secondary={getActiveNavbar(routesLinks)}
                {...rest}
              />
            </div>
            <div className="mx-6 mt-4 mb-6 min-h-[calc(100vh-120px)]">
              <Routes>
                {routesLinks.map((prop, key) => {
                  return (
                    <Route
                      path={`/${prop.path}`}
                      element={prop.component}
                      key={key}
                    />
                  );
                })}
                <Route
                  path="/auth/sign-in"
                  element={<navigate to="/admin/Dashboard" replace />}
                />
                 <Route
                  path="/*"
                  element={<ErrorPaheInner/>}
                />
              </Routes>
            </div>
            {/* <div className="p-3">
              <Footer />
            </div> */}
          </div>
        </main>
      </div>
    </div>
  );
}
